import { createFileRoute } from '@tanstack/react-router';

import { ComingSoonPage } from '@/components/coming-soon-page';

export const Route = createFileRoute('/billing')({
  component: () => (
    <ComingSoonPage
      title="Billing"
      description="Billing and claims will appear here once the billing integration lands."
      testId="billing-page"
    />
  ),
});
